import { ROUTES_CONFIG } from '@/config/routes.config';
import { useAuth } from '@/hooks/use-auth';
import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) return <div>Loading...</div>;
  if (!user) return <Navigate to={ROUTES_CONFIG.AUTH.LOGIN.$buildPath({})} />;

  return <Outlet />;
};